import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';
import { Observable, throwError, EMPTY, catchError } from 'rxjs';
import { ToastService } from '../_services';
import * as Sentry from '@sentry/angular';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  private readonly toastService: ToastService = inject(ToastService);

  intercept(req: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
    return handler.handle(req).pipe(
      catchError((err) => {
        // Let the JWT interceptor handle refresh flow for auth errors
        if (err?.status === 401) {
          return throwError(() => err);
        }
        const isNetworkAbort = err?.status === 0;
        const g: any = typeof globalThis !== 'undefined' ? (globalThis as any) : {};
        const isKarma = !!g.__karma__;
        const isTestEnvFlag = !!(g.process && g.process.env && (g.process.env.NG_TEST || g.process.env.JEST_WORKER_ID));
        const isTestMode = isKarma || isTestEnvFlag;
        const errMsg = ErrorHandlerInterceptor.errorMessaging(err);
        if (!(isNetworkAbort && isTestMode) && this.toastService) {
          this.toastService.queue.next({
            message: errMsg,
            panelClass: 'slick-custom-snackbar-error',
          });
        }
        if (isNetworkAbort && isTestMode) {
          // eslint-disable-next-line no-console
          console.warn('[test-mode] Suppressed network abort (status 0):', errMsg);
          return EMPTY as unknown as Observable<never>;
        }
        return throwError(() => err);
      })
    );
    // return handler.handle(req);
  }

  public static errorMessaging(err): string {
    // Need to check both err.error.message and err.message due to different error structures
    // Need to update all API error responses to have consistent structure
    let errMsg = 'Error occurred.';
    if (err.status === 429) {
      errMsg = err.error?.message || 'Too many attempts. Please try again later.';
    } else if (
      err.error?.message?.includes('User not found.') ||
      err.error?.message?.includes('Invalid credentials.')
    ) {
      errMsg = 'Invalid email or password, please try again.';
    } else if (
      err.message.includes('Invalid refresh token.') ||
      err.error?.message?.includes('Invalid refresh token.')
    ) {
      errMsg = 'Your session has expired, please log in again.';
    } else if (
      err.message.includes('Microsoft identity not found') ||
      err.error?.message?.includes('Microsoft identity not found')
    ) {
      errMsg = 'Microsoft identity not found in Slick+';
    } else if (err.errors && Array.isArray(err.errors)) {
      errMsg = 'Invalid email or password, please try again.';
    }
    Sentry.captureMessage('Error occurred:', err);
    return errMsg;
  }
}
